import CrudCustom from '../../../libs/custom/CrudCustom';

let PeriodeFiskalService = new CrudCustom('/periode-fiskals');
export default PeriodeFiskalService;
